import { STUDIO_SEARCH_DEFAULT_SORT_BY } from 'constants/app';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import parseStudioSearchPageParamsServer from 'utils/routes/parseStudioSearchPageParamsServer';
import sanitiseXSS from 'utils/sanitiseXSS';
import { setStudioSearchPageNrAction, setStudioSearchQueryAction, setStudioSearchSortByAction } from '../slice';
import setStudioSearchFiltersSelectionPHPWayOperation from './setStudioSearchFiltersSelectionPHPWayOperation';

const setParamsFromQueryStringServerOperation =
  (queryString: URLSearchParams | any) => (dispatch: ThunkDispatch<Store, undefined, AnyAction>) => {
    let { pageNr, sortBy, query } = parseStudioSearchPageParamsServer(queryString);
    pageNr = pageNr || 1;
    sortBy = sortBy || STUDIO_SEARCH_DEFAULT_SORT_BY;

    pageNr *= 1;
    sortBy = sanitiseXSS(sortBy);
    query = sanitiseXSS(query);

    dispatch(setStudioSearchPageNrAction(pageNr));
    dispatch(setStudioSearchSortByAction(sortBy));
    dispatch(setStudioSearchQueryAction(query));
    dispatch(setStudioSearchFiltersSelectionPHPWayOperation(queryString));
  };

export default setParamsFromQueryStringServerOperation;
